import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { HttpClient, HttpClientModule } from "@angular/common/http";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from "@angular/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { CommonModule } from "@angular/common";
import { RouterModule, Routes } from "@angular/router";
import { SharedModule } from "src/shared/shared.module";
import { EventListPage } from "./event-list/event-list";
import { IonicModule } from "@ionic/angular";
import { FormsModule } from "@angular/forms";
const routes: Routes = [
    { path: 'create', loadChildren: () =>
      import('./create/event-create.module').then(m => m.EventCreateModule)
    },
    { path: 'details', loadChildren: () =>
      import('./details/event-detail.module').then(m => m.EventDetailModule)
    },
    { path: 'activity-tabs', loadChildren: () =>
      import('./event-activity-tabs/event-activity.module').then(m => m.EventActivityModule)
    },
    { path: 'list', loadComponent: () =>
      import('./event-list/event-list').then(m => m.EventListPage)
    },
    { path: 'main', loadChildren: () =>
      import('./main/event-main.module').then(m => m.EventMainModule)
    },
  ];
@NgModule({
    declarations: [
      EventListPage
    ],
    imports: [
        HttpClientModule,
        SharedModule,
        CommonModule,
        RouterModule,
        TranslateModule,
        IonicModule,
        FormsModule,
        RouterModule.forChild(routes)

    ],
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA,
        NO_ERRORS_SCHEMA
    ],
    exports: [
    ]
  })
  export class EventModule { }
  export function createTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http, './assets/i18n/', '.json');
  }